import styled, { css } from "styled-components";

export const Label = styled.label`
  color: ${({ theme }) => theme.text?.secondary || "#616161"};
  font-size: 14px;
  font-weight: 300;
  margin-bottom: 2px;
`;

const baseInputStyle = css`
  background: ${({ theme }) => theme.background?.secondary || "#fff"};
  border: 1px solid ${({ theme }) => theme.border?.color || "#ebebeb"};
  color: ${({ theme }) => theme.text?.primary || "#000"};
  padding: 4px 8px;
`;

export const Input = styled.input`
  ${baseInputStyle}
`;

export const Textarea = styled.textarea`
  ${baseInputStyle}

  resize: none;
`;

export const Helper = styled.span`
  color: ${({ theme }) => theme.text?.secondary || "#616161"};
  font-size: 13px;
`;
